import React from 'react';
import { useParams } from 'react-router-dom';
import Page from '../../components/Page';
import Form from '../../components/json-forms/Form';
import PasswordBox from '../../components/PasswordBox';
import { Box } from '@mui/material';
import FormSent from '../../components/json-forms/FormSent';
import { verifyCodeQuestionnaireAction } from '../../services/request';

export default function QuestionnaireFormPage() {
  const [isCodeValid, setIsCodeValid] = React.useState(false);
  const [isSent, setIsSent] = React.useState(false);
  const { id } = useParams();

  return (
    <Page title="Kwestionariusz">
      {isCodeValid
        ? <Box p={2}>
          {!isSent ? <Form identifier="kwestionariusz" initData={{ id }}/> : <FormSent identifier="kwestionariusz" />}
        </Box>
        : <PasswordBox
          id={id}
          setIsCodeValid={setIsCodeValid}
          setIsSent={setIsSent}
          action={verifyCodeQuestionnaireAction}
          buttonText="Zobacz kwestionariusz"
          numbersOnly={true}
        />}
    </Page>
  );
};
